import React from "react";
import CardsView from "./view/CardsView";

const Cards: React.FC = () => {
  return (
    <CardsView />
  );
}

export default Cards;
